
export default {
    staticUser: {
        user_code: "518", // dev
    }
};



